import store from '@/store'
import { push, pushEvent } from '@/helpers/datalayer'
import { listen } from '@/helpers/eventbus'
import sha256 from 'crypto-js/sha256'

/**
 * @return {{user_group: string | undefined}}
 */
const getUserTrackingData = () => {

  const user = store.getters['user']

  return {
    user_group: user?.roles.map(({label}) => label).join(','),
  }
}

function setupUserTracking() {

  const sanitizeUser = (user) => {

    const privateFields = ['ID', 'token']
    privateFields.forEach(field => {
      if (user?.[field]) {
        user = {
          ...user,
          [field]: null,
        }
      }
    })

      const sensitiveFields = ['user_email', 'first_name', 'last_name', 'customer_number']

      sensitiveFields.forEach(field => {
        if (user?.[field]) {
          user = {
            ...user,
            [field]: sha256(user[field]).toString(),
          }
        }
      })

      return user
    }

  // Track user changes
  store.watch(
    (state) => state.user.user,
    (user) => push({ user: sanitizeUser(user) }),
    { immediate: true},
  )

  // Track user logins
  
    listen(
      'user::login',
      () => {
        const data = getUserTrackingData();
        pushEvent({name: 'login', id: 'A01', data})
      },
    )
}

function setupCartTracking() {

  // Track adding items to cart
  listen('cart::item-added', item => {

    const userTrackingData = getUserTrackingData();

    pushEvent({
      name: 'add_to_cart',
      id: 'A02',
      data: {
        product_name: item.title,
        ...userTrackingData,
      }
    })
  });

  // Track downloads
  const placementMapping = {
    card: 'catalogue',
  }

  listen('cart::download', ({ context, title }) => {

    let placement = placementMapping[context] ?? context;
    let id = 'A03';
    let productName = title;

    if (context === 'cart') {
      productName = store.getters['cart']
        .map(({ title }) => title)
        .filter(Boolean)
        .sort()
        .join(',');
    }

    pushEvent({
      name: 'download_image',
      id,
      data: {
        ...getUserTrackingData(),
        product_name: productName,
        placement,
      },
    })


    switch (context) {
      case 'card':
        id = 'A04';
        break;
      case 'cart':
        id = 'A05';
        break;
    }

    let baseEvent = {
      name: `download_image_${placement}`,
      id,
      data: {
        ...getUserTrackingData(),
        product_name: productName
      }
    }

    let events = [baseEvent];

    // We want to trigger an event for every item in the cart
    if (context === 'cart') {
      events = [];
      store.getters['cart'].forEach(({ title }) => {
        events.push({
          ...baseEvent,
          data: {
            ...baseEvent.data,
            product_name: title,
          }
        })
      });
    }

    events.forEach((event) => pushEvent(event))
  });
}

export function useTracking() {
  setupUserTracking()
  setupCartTracking()
}
